<template>
  <v-flex class="overlay" v-if="this.$store.state.alert.alert">
    <v-card style="width: 100%; max-width:100%;">
      <v-card-title>
        <v-layout column>
          <v-flex>
            <v-icon large :color="this.$store.state.alert.color">{{this.$store.state.alert.icon}}</v-icon>
          </v-flex>
          <v-flex align-center>
            <h4 class="display-1">{{ $t(this.$store.state.alert.alert_message) }}</h4>
            <pre  style="width: 100%; max-width:100%; white-space: pre-wrap;" v-if="this.$store.state.alert.full_alert_message"><span>{{ this.$store.state.alert.full_alert_message }}</span></pre>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-actions>
        <v-btn
          color="error"
          @click="close"
          block
          v-if="this.$store.state.alert.closeable"
        >{{ $t('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "rMessageOverlay",
  methods: {
    close: function() {
      this.$store.state.alert.alert = false;
    }
  }
};
</script>

<style scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(39, 42, 43, 0.8);
  transition: opacity 200ms ease-in-out;
}

button {
  font-weight: bold;
  color: gray;
}

.overlay-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(39, 42, 43, 0.9);
  border: 1px dotted white;
  border-radius: 6px;
  padding: 1em;
  transition: opacity 200ms ease-in-out;
}

.v-card {
  border: 4px solid #ff5252 !important;
}
</style>